<template>
  <div
    class="image"
    :class="getVariant('image')"
  >
    <!-- Wrapper -->
    <div

      class="image__wrapper"
    >
      <picture>
        <source
          media="--small"
          :data-srcset="mobileImageId"
        >

        <source
          media="--large"
          :data-srcset="imageId"
        >
        <img
          class="lazyload"
          data-sizes="auto"
          :data-src="imageId"
        >
      </picture>
    </div>

    <!-- Header -->
    <div class="image__header">
      <!-- Subtitle -->
      <div class="image__header__subtitle">
        <slot
          name="title-small"
        />
      </div>

      <!-- Title -->
      <div
        class="image__header__title"
      >
        <slot name="title-normal" />
      </div>
    </div>

    <!-- Footer -->
    <div class="image__footer">
      <!-- Skills -->
      <div class="image__footer__skills">
        <div class="image__footer__skills__title">
          <slot name="skill-title" />
        </div>
        <template
          v-for="skill in skills"
        >
          <slot
            name="skill"
            :skill="skill"
          />
        </template>
      </div>
      <!-- Icon (scroll) -->
      <div
        class="image__footer__icon image__footer__icon--left"
      >
        <icon-scroll-view />
      </div>

      <!-- Icon (arrow) -->
      <div class="image__footer__icon image__footer__icon--bottom">
        <i class="icon-arrow animation-jump" />
      </div>
    </div>
  </div>
</template>

<script>
import variant from '@/mixins/variant';

export default {
  name: 'ImageView',

  components: {
    IconScrollView: () => import('@/icons/icon-scroll-view')
  },

  mixins: [variant],

  props: {
    imageId: {
      type: String,
      required: false,
      default: ''
    },

    mobileImageId: {
      type: String,
      required: false,
      default: ''
    },

    skills: {
      type: Array,
      required: false,
      default: () => []
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/image/image-view.scss"></style>



// WEBPACK FOOTER //
// image-view.vue